import { useTranslation } from 'react-i18next';

import { VaultUserLayout } from '../components/VaultUserLayout';
import { VaultComplianceContent } from '../components/VaultComplianceContent';

/**
 * VaultCompliancePage
 *
 * Documentation detaillee sur la conformite legale du coffre-fort numerique.
 * Version pour les vault users (employes) avec VaultUserLayout.
 */
export const VaultCompliancePage = () => {
  const { t } = useTranslation();

  return (
    <VaultUserLayout
      title={t('vault.compliance.title', 'Conformite & Securite')}
      subtitle={t('vault.compliance.subtitle', 'Documentation legale du coffre-fort numerique')}
      showBackButton
      backPath="/my-vaults"
    >
      <VaultComplianceContent />
    </VaultUserLayout>
  );
};
